import { useState } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun, Menu, X, ArrowUpRight, Phone } from "lucide-react";
import { LogoMark, PHONE_TEL, PHONE_DISPLAY } from "@/lib/site";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Hosting Tiers", href: "#hosting", testid: "nav-link-hosting" },
  { label: "Case Studies", href: "#cases", testid: "nav-link-cases" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Header = ({ dark, onToggleTheme, basePath = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 dark:bg-slate-950/70 border-b border-slate-200/80 dark:border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 sm:h-20 flex items-center justify-between gap-4">
        <a href={basePath ? "/" : "#top"} data-testid="header-logo" className="flex items-center gap-3 shrink-0">
          <LogoMark className="w-9 h-9" />
          <span className="font-display font-bold text-lg tracking-tight">
            Wynova<span className="text-primary"> Systems</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.testid} href={`${basePath}${l.href}`} data-testid={l.testid}
               className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-cyan-400 transition-colors">
              {l.label}
            </a>
          ))}
          <Link to="/seo" data-testid="nav-link-seo"
                className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-cyan-400 transition-colors">
            SEO
          </Link>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <button onClick={onToggleTheme} data-testid="theme-toggle-btn" aria-label="Toggle theme"
                  className="p-2.5 rounded-full border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-primary hover:text-primary transition-colors">
            {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
          <a href={PHONE_TEL} data-testid="nav-cta-phone"
             className="hidden sm:inline-flex p-2.5 rounded-full border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-primary hover:text-primary transition-colors"
             aria-label={`Call us on ${PHONE_DISPLAY}`}>
            <Phone className="w-4 h-4" />
          </a>
          <Link to="/portal" data-testid="nav-cta-portal"
             className="hidden sm:inline-flex items-center px-4 sm:px-5 py-2.5 rounded-full border-2 border-slate-900/80 dark:border-slate-200/80 text-sm font-semibold hover:bg-slate-900 hover:text-white dark:hover:bg-white dark:hover:text-slate-900 transition-colors">
            Client Portal
          </Link>
          <a href={`${basePath}#contact`} data-testid="nav-cta-book-call"
             className="hidden sm:inline-flex items-center gap-1.5 px-4 sm:px-5 py-2.5 rounded-full bg-primary text-white text-sm font-semibold hover:bg-blue-700 transition-colors">
            Book a Free Demo <ArrowUpRight className="w-4 h-4" />
          </a>
          <button onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu"
                  className="lg:hidden p-2.5 rounded-full border border-slate-200 dark:border-slate-700">
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 px-6 py-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <a key={l.testid} href={`${basePath}${l.href}`} onClick={() => setOpen(false)}
               className="py-3 text-base font-medium text-slate-700 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800 last:border-0">
              {l.label}
            </a>
          ))}
          <Link to="/seo" onClick={() => setOpen(false)} className="py-3 text-base font-medium text-slate-700 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800">SEO Packages</Link>
          <Link to="/portal" onClick={() => setOpen(false)} className="py-3 text-base font-medium text-slate-700 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800">Client Portal</Link>
          <Link to="/admin" onClick={() => setOpen(false)} className="py-3 text-sm text-slate-400">Admin Portal</Link>
        </nav>
      )}
    </header>
  );
};
